import path from 'node:path';
import type { SupportedServicePlugin } from '@wix/cli-app-definitions';
import { SERVICE_PLUGINS_DIR } from '@wix/cli-app-definitions';
import type { DevCenterComponent } from '../dev-center-component.js';
import { composeValidations, pathValidation } from './common.js';
import { ServicePluginTypeToFolderName } from '../backend/config.js';

function servicePluginExistsValidation(
  existingServicePlugins: Array<DevCenterComponent<'ServicePlugin'>>,
  servicePluginType?: SupportedServicePlugin
) {
  return (folder: string) => {
    return existingServicePlugins.every((servicePlugin) => {
      const servicePluginRelativePath = path.relative(
        SERVICE_PLUGINS_DIR,
        servicePlugin.relativePath
      );

      const pluginName = path.dirname(servicePluginRelativePath);

      return (
        servicePluginType &&
        path.join(ServicePluginTypeToFolderName(servicePluginType), folder) !==
          pluginName
      );
    });
  };
}

export function createServicePluginValidation(
  servicePlugins: Array<DevCenterComponent<'ServicePlugin'>>,
  servicePluginType?: SupportedServicePlugin
) {
  return composeValidations([
    [
      servicePluginExistsValidation(servicePlugins, servicePluginType),
      'Plugin name must be unique',
    ],
    [
      (path: string) => path.length < 20,
      'Plugin name must be shorter than 20 characters',
    ],
    [
      pathValidation,
      'The plugin folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
